import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuService {
  isAuditor: boolean;
  isplanApprover: boolean;
  isAuditee: boolean;
  isPeerReviewer: boolean;
  isClosureReviewer: boolean;
  isClosureApprover: boolean;
  isAssignedUser: boolean;
  findingId: number;
  findingsData: any = {};
  followUpId: number;
  recommendationId: number;
  questionTemplateId: any;
  tabName: any;
  detailsTabName: any;
  finalRiskScore: any;
  finalRiskStatus: any;
  finalRiskComments: any;
  questionnaireId: any;
  selectedTabIndex: any;
  auditScheduleStatusList: any = ["Draft(Schedule)", "Re-Draft(Schedule)", "Pending Schedule Approval", "Schedule Rejected"];
  auditPlanStatusList: any = ["Draft(Plan)", "Re-Draft(Plan)", "Pending Plan Approval", "Plan Rejected", "Planned", "Initiated", "Initiated/Auditor Requested More Info. On Q&A Responses", "Initiated/Auditor Requested More Info. On Responses", "Initiated/Received Q&A Response", "Plan Created", "Scheduled"];
  auditConductStatusList: any = ["Auditor Requested More Info. On Q&A Responses", "Auditor Requested More Info. On Responses", "Closure Approval Rejected",
    "Closure Approver Requested More Info.", "Closure Review Rejected", "Closure Reviewer Requested More Info.", "Findings In Progress"
    , "Findings In Progress", "In Progress", "In Progress/Auditor Requested More Info. On Q&A Responses", "In Progress/Q&A Inprogress",
    "In Progress/Q&A More Info. Requested", "In Progress/Q&A Pending", "In Progress/Received Q&A Response", "Peer Review Rejected",
    "Peer Reviewer Requested More Info.", "Pending Closure Approval", "Pending Closure Review", "Pending Findings", "Pending Peer Review",
    "Received Q&A Response", "Initiated", "Initiated/Auditor Requested More Info. On Q&A Responses", "Initiated/Auditor Requested More Info. On Responses", "Initiated/Received Q&A Response"
    , "Peer Review Inprogress", "Closure Review Inprogress", "Closure Approval Inprogress", "Pending Auditee Review", "Auditee Requested More Info.", "Pending Auditee Review", "Auditee Accepted"];
  specificButtonforschedule: any = ["Re-Schedule", "Re-Submit for Approval(Schedule)", "Submit for Approval(Schedule)", "Cancel Schedule", "Lock Schedule", "Unlock Schedule", "Create New Plan", "Re-Submit for Approval(Plan)"];
  specificButtonforPlan: any = ["Re-Plan", "Cancel Plan", "Re-Submit for Approval(Plan)", "Start Audit", "Add New Plan", "Initiate Plan"];
  auditPageFrom: any = "";
  list: any = {};
  priorGroup: any;
  responseReviewedByUser: any;
  implementationReviewedByUser: any;
  questionnaireList: any = [];
  selectedLeadAuditor = [];
  selectedScheduleApprover = [];
  selectedPlanApprover = [];

  disableButton: boolean = false;
  isIncludedinDisablebtn: boolean = false;
  isFromFindingDetails: boolean = false;
  ParallelWorkflowfindingId: number;
}
